import React from 'react';
import { useSelector } from "react-redux";
import { Spin, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import SelfAssessmentWordCard from "../../components/WordCard/SelfAssessment/SelfAssessmentWordCard";
import usePracticeSession from "../../hooks/usePracticeSession";

import SpellingFromAudioEnglishGbWordCard
    from "../../components/WordCard/SpellingFromAudio/SpellingFromAudioEnglishGbWordCard";
import SentenceBuildingFromWordEnglishGbWordCard
    from "../../components/WordCard/SentenceBuildingFromWord/SentenceBuildingFromWordEnglishGbWordCard";
import ChooseTransportationEnglishGbWordCard
    from "../../components/WordCard/ChooseTransportation/ChooseTransportationEnglishGbWordCard";
import ChooseHeadwordEnglishGbWordCard from "../../components/WordCard/ChooseHeadword/ChooseHeadwordEnglishGbWordCard";
import { wordPracticeFormatsFor } from '../../constants/wordPractice';
import useTranslation from '../../hooks/useTranslation';

const CARD_BY_FORMAT = {
    SELF_ASSESSMENT: SelfAssessmentWordCard,
    SPELLING_FROM_AUDIO: SpellingFromAudioEnglishGbWordCard,
    SENTENCE_BUILDING_FROM_WORD: SentenceBuildingFromWordEnglishGbWordCard,
    ORIGINAL_TO_TRANSLATION: ChooseTransportationEnglishGbWordCard,
    TRANSLATION_TO_ORIGINAL: ChooseHeadwordEnglishGbWordCard,
};

const WordRunPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { locale } = useSelector((state) => state.deck.selectedDeck);
    const { practiceId, learningMethod, practiceFormat } = useSelector((state) => state.practice);

    // Сессия ведётся локально: вопросы приходят окном, ответы уходят пачкой.
    const { item, isLoading, finished, error, answer } = usePracticeSession({
        practiceId,
        learningMethod,
    });

    // Компонент по формату — из той же таблицы, что и страница выбора. Формат, которого
    // для языка колоды нет (или который остался в Redux от прошлой сессии), показывается
    // самооценкой: под остальные языки других карточек пока не написано.
    const isSupported = wordPracticeFormatsFor(locale.code).some(({ format }) => format === practiceFormat);
    const WordCardComponent = (isSupported && CARD_BY_FORMAT[practiceFormat]) || SelfAssessmentWordCard;

    if (error) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{error}</p>
                <Button type="primary" onClick={() => navigate('/learn')}>
                    {t('practice.run.back')}
                </Button>
            </div>
        );
    }

    // Конец практики приходит признаком в ответе, а не текстом ошибки.
    if (finished) {
        return (
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <p>{t('practice.run.finished')}</p>
                <Button type="primary" onClick={() => navigate('/learn')}>
                    {t('practice.run.back')}
                </Button>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            {item ? (
                <WordCardComponent
                    word={item}
                    // Подробности ответа приходят от самой карточки: только она знает,
                    // сколько было вариантов, сколько попыток и когда человек выбрал.
                    handleCorrectClick={(evidence) => answer(true, evidence)}
                    handleIncorrectClick={(evidence) => answer(false, evidence)}
                    locale={locale}
                />
            ) : (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <p>{t('practice.run.noItem')}</p>
                </div>
            )}

            {isLoading && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 1000,
                }}>
                    <Spin tip={t('practice.run.loading')} size="large" />
                </div>
            )}
        </div>
    );
};

export default WordRunPage;
